module.exports = __webpack_public_path__ + "img/DieBurg.166af7ca.svg";